import { Box, BoxProps, createUseVariantStyle, forwardRef } from '@bonusly/design-system';

import { DropdownVariant } from './types';

interface Props extends BoxProps {
	role?: string;
	variant?: DropdownVariant;
}

const useVariantStyle = createUseVariantStyle({
	variant: {
		floating: {
			borderRadius: 'md',
			_focus: { backgroundColor: 'gray.25' },
			_hover: { backgroundColor: 'grayAlpha.100' },
		},
		static: {
			border: 0,
			borderRadius: 'sm',
			_focus: { backgroundColor: 'gray.25' },
			_hover: { backgroundColor: 'grayAlpha.100' },
		},
	},
});

export const DropdownOption = forwardRef(({ variant = 'static', ...rest }: Props, ref) => {
	return (
		<Box
			bg="white"
			borderColor="gray.50"
			borderStyle="solid"
			cursor="pointer"
			listStyleType="none"
			p={2}
			transitionDuration="normal"
			transitionProperty="common"
			as="li"
			role="option"
			tabIndex={0}
			ref={ref}
			{...useVariantStyle({ variant })}
			{...rest}
		/>
	);
});

export type { Props as DropdownOptionProps };
